import React from "react";

import { Box, Button, Typography } from "@mui/material";

const TenantNotFound = () => {
  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h4" sx={{ color: "text.primary" }}>
        Tenant not found
      </Typography>
      <Button
        variant="contained"
        onClick={() => (window.location.href = "https://fadepilot.com")}
      >
        Go to FadePilot
      </Button>
    </Box>
  );
};

export default TenantNotFound;
